import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetSonarObjectPageLayoutsRequest = {
	sonarObjectId: number;
};

export type GetSonarObjectPageLayoutsResponse = Array<{ id: number; name: string; }>;

export const getSonarObjectPageLayouts = createGetEndpoint<
	GetSonarObjectPageLayoutsRequest,
	GetSonarObjectPageLayoutsResponse
>(({ sonarObjectId }) => `/api/v3/salesforce/entity-definitions/${sonarObjectId}/page-layouts`);
